/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type holidays_CreateHolidayRequest = {
    canton?: string;
    /**
     * Optional childcare/location ID. NULL/omitted = org-wide; set = location-specific.
     */
    childcareId?: string;
    country: string;
    description: string;
    /**
     * ISO 8601 date (YYYY-MM-DD)
     */
    holidayDate: string;
    holidayType: holidays_CreateHolidayRequest.holidayType;
};
export namespace holidays_CreateHolidayRequest {
    export enum holidayType {
        PUBLIC_HOLIDAY = 'PUBLIC_HOLIDAY',
        SCHOOL_CLOSURE = 'SCHOOL_CLOSURE',
        DAYCARE_CLOSURE = 'DAYCARE_CLOSURE',
    }
}

